$('#ticker').eocjsNewsticker({
  divider:    ' ',
  speed:      25
});


// First element
// First element
$('#shopify-section-template--19957055029588__16107317833372878f > div > div > div > div > div:nth-child(2) > div > div > div').append('<a href="/collections" class="btn btn-theme c-image-btn gradient-theme">Shoppa nu!</a>');


$('#shopify-section-template--19957055029588__161073155008918935 > div > div > div > div > div:nth-child(1) > div > div > div').append('<a href="/collections" class="btn btn-theme c-image-btn gradient-theme">Shoppa nu!</a>');

/* product grid */




/* end product grid */
		$.fn.extend({
			'ifexists': function (callback) {
				if (this.length > 0) {
					return callback($(this));
				}
			}
		});		
		$('.swiper').ifexists(function(elem) {
			// forEach function
			let forEach = (array, callback, scope) => {
				for (let i = 0; i < array.length; i++) {
					callback.call(scope, i, array[i]); // passes back stuff we need
				}
			};
	
			// Carousel initialisation
			let carousels = document.querySelectorAll('.swiper');
			forEach(carousels, (index, value) => {
				let userOptions, pagerOptions;
				if (value.dataset.swiperOptions != undefined) userOptions = JSON.parse(value.dataset.swiperOptions);
				const options = {
					...userOptions,
					...pagerOptions
				};
				const swiper = new Swiper(value, options); // eslint-disable-line no-undef
			});
		});